export const routes_administracion = [
    {
        path: 'partidas/lista',
        name: 'Partidas lista',
        component: () => import('./pages/partidas/lista')
    }, {
        path: 'partidas/consultar/:id',
        name: 'Partidas consultar',
        component: () => import('./pages/partidas/consultar')
    }, {
        path: 'partidas/actualizar/:id',
        name: 'Partidas actualizar',
        component: () => import('./pages/partidas/actualizar')
    }, {
        path: 'partidas/aprobar/:id',
        name: 'Partidas aprobar',
        component: () => import('./pages/partidas/aprobar')
    }, {
        path: 'partidas/agregar',
        name: 'Partidas agregar',
        component: () => import('./pages/partidas/agregar')
    },

    {
        path: 'partida/lista',
        name: 'Catalogo partida lista',
        component: () => import('./pages/catalogos/lista_partidas')
    },

    {
        path: 'unidad_medida/lista',
        name: 'Catalogo medida lista',
        component: () => import('./pages/catalogos/lista_unidad_medida')
    },

    {
        path: 'tipo_partida/lista',
        name: 'Catalogo tipo partida lista',
        component: () => import('./pages/catalogos/lista_tipo_partidas')
    },

    {
        path: 'catalogos/lista',
        name: 'Catalogo lista',
        component: () => import('./pages/catalogos')
    },

    {
        path: 'reportes/lista',
        name: 'Reporte lista',
        component: () => import('./pages/reportes')
    },

    {
        path: 'politicas',
        name: 'policies',
        component: () => import('./pages/policies')
    }

]